const paletteColors = require('../assets/styles/utils/palette.scss');

const chevronColors = paletteColors;
const chevronDefaultColor = paletteColors.black

const chevronDirections = {
    left: '42.63,70.8 3.375,38.087 42.63,5.375',
    down: '3.375,38.087 42.63,70.8 78,38.087',
    up: '100 0, 0 100, 100 100'
}
const chevronDefaultDirection = chevronDirections.down

export {
    chevronColors,
    chevronDefaultColor,
    chevronDirections,
    chevronDefaultDirection
}